import React from 'react';
import _ from 'lodash';

import {connect} from 'react-redux';

import CheckBox from 'components/CheckBox';
import MoneyInput from 'components/MoneyInput';
import {RoomCheckDescription} from 'containers/BookingSetDetail/components';

import {
  editDepartureRoomCheckDescription,
  fetchDepartureRoomChecks,
  fetchDepartureRoomCheck,
  fetchDepositSummary,
  fetchRoomChecksTimeline,
  editDepartureRoomCheckTotalDamageCharge,
  editDepartureRoomCheckChargeFromDeposit,
  editDepartureRoomCheckReleaseFullDeposit,
  editDepartureRoomCheckStatus,
  MODALS,
  ROOM_CHECK_STATUSES
} from 'ducks/bookingSets';

import {composeActions} from 'ducks/common';

import {storeDataInModal, selectModal} from 'ducks/modals';

import ErrorBlock from 'components/ErrorBlock';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';
import './styles.css';
import Label from 'components/Label';

interface DepartureRoomCheckProps {
  id: number;
  description: string;
  totalDamageCharge: string;
  roomType: string;
  releaseFullDeposit: boolean;
  chargeFromDeposit: boolean;
  status: string;
}

interface DepartureRoomCheckDetailsProps {
  departureRoomCheck: DepartureRoomCheckProps;
  bookingSetId: number;
  edittingDescription: boolean;
  fetchDepartureRoomCheckExtraActions: any;
  editDepartureRoomCheckDescription: any;
  editDepartureRoomCheckTotalDamageCharge: any;
  editDepartureRoomCheckChargeFromDeposit: any;
  editDepartureRoomCheckReleaseFullDeposit: any;
  editDepartureRoomCheckStatus: any;
  storeDataInModal: any;
  composeActions: any;
  releaseFullDepositError: any;
  totalDamageChargeError: any;
  requiresPermission: any;
  locationRef: string;
}

class DepartureRoomCheckDetails extends React.Component<
  DepartureRoomCheckDetailsProps
> {
  state = {
    totalDamageChargeEddited: null,
    editDescription: false
  };

  submitEditDescriptionForm = ({newDescription}) => {
    const {bookingSetId, departureRoomCheck} = this.props;
    const departureRoomCheckId = departureRoomCheck.id;

    const extraActions = [
      () =>
        fetchDepartureRoomCheck(
          {roomCheckId: departureRoomCheckId, bookingSetId},
          [
            data =>
              this.props.storeDataInModal({
                modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
                data: {departureRoomCheck: data, edittingDescription: false}
              })
          ]
        ),
      () => fetchDepartureRoomChecks({bookingSetId})
    ];

    this.props.composeActions([
      () =>
        this.props.storeDataInModal({
          modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
          data: {edittingDescription: true}
        }),
      () =>
        this.props.editDepartureRoomCheckDescription(
          {
            bookingSetId,
            departureRoomCheckId,
            newDescription
          },
          extraActions
        )
    ]);
  };

  editTotalDamageCharge = () => {
    const {bookingSetId, departureRoomCheck} = this.props;
    const departureRoomCheckId = departureRoomCheck.id;

    const extraActions = [
      () =>
        fetchDepartureRoomCheck(
          {roomCheckId: departureRoomCheckId, bookingSetId},
          this.props.fetchDepartureRoomCheckExtraActions()
        ),
      () => fetchDepartureRoomChecks({bookingSetId}),
      () => fetchDepositSummary({bookingSetId}),
      () =>
        storeDataInModal({
          modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
          data: {
            totalDamageChargeError: null
          }
        })
    ];

    const failureExtraAction = [
      ({errors}) =>
        storeDataInModal({
          modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
          data: {
            totalDamageChargeError: _.get(errors, '_error', null)
          }
        })
    ];

    this.props.editDepartureRoomCheckTotalDamageCharge(
      {
        bookingSetId,
        departureRoomCheckId,
        newTotalDamageCharge: this.state.totalDamageChargeEddited
      },
      extraActions,
      failureExtraAction
    );
  };

  debouncedEditTotalDamageCharge = _.debounce(this.editTotalDamageCharge, 1000);

  onTotalDamageChargeChange = event => {
    // The default value of MoneyInput(input type="number") is ''
    const newTotalDamageChargeValue = event.target.value || null;

    this.setState(
      {totalDamageChargeEddited: newTotalDamageChargeValue},
      this.debouncedEditTotalDamageCharge
    );
  };

  onChargeFromDepositChange = event => {
    const newChargeFromDeposit = event.target.checked;

    const {bookingSetId, departureRoomCheck, locationRef} = this.props;
    const departureRoomCheckId = departureRoomCheck.id;

    this.props.requiresPermission(
      {permission: PERMISSIONS.RETAIN_FROM_DEPOSIT, locationRef},
      () => {
        const extraActions = [
          () =>
            fetchDepartureRoomCheck(
              {roomCheckId: departureRoomCheckId, bookingSetId},
              this.props.fetchDepartureRoomCheckExtraActions()
            ),
          () => fetchDepartureRoomChecks({bookingSetId}),
          () => fetchDepositSummary({bookingSetId}),
          () => fetchRoomChecksTimeline({bookingSetId})
        ];

        this.props.storeDataInModal({
          modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
          data: {
            releaseFullDepositError: null
          }
        });

        this.props.editDepartureRoomCheckChargeFromDeposit(
          {
            bookingSetId,
            departureRoomCheckId,
            newChargeFromDeposit
          },
          extraActions
        );
      }
    );
  };

  onReleaseFullDepositChange = event => {
    const newReleaseFullDeposit = event.target.checked;

    const {bookingSetId, departureRoomCheck, locationRef} = this.props;
    const departureRoomCheckId = departureRoomCheck.id;

    this.props.requiresPermission(
      {permission: PERMISSIONS.RELEASE_FULL_DEPOSIT, locationRef},
      () => {
        const extraActions = [
          () =>
            fetchDepartureRoomCheck(
              {roomCheckId: departureRoomCheckId, bookingSetId},
              this.props.fetchDepartureRoomCheckExtraActions()
            ),
          () => fetchDepartureRoomChecks({bookingSetId}),
          () => fetchDepositSummary({bookingSetId}),
          () =>
            storeDataInModal({
              modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
              data: {
                releaseFullDepositError: null
              }
            })
        ];

        const failureExtraAction = [
          ({errors}) =>
            storeDataInModal({
              modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
              data: {
                releaseFullDepositError: _.get(errors, '_error', null)
              }
            })
        ];

        this.props.editDepartureRoomCheckReleaseFullDeposit(
          {
            bookingSetId,
            departureRoomCheckId,
            newReleaseFullDeposit
          },
          extraActions,
          failureExtraAction
        );
      }
    );
  };

  onStatusChange = () => {
    const {bookingSetId, departureRoomCheck, locationRef} = this.props;
    const departureRoomCheckId = departureRoomCheck.id;

    this.props.requiresPermission(
      {permission: PERMISSIONS.COMPLETE_ROOM_CHECK, locationRef},

      () => {
        const extraActions = [
          () =>
            fetchDepartureRoomCheck(
              {roomCheckId: departureRoomCheckId, bookingSetId},
              this.props.fetchDepartureRoomCheckExtraActions()
            ),
          () => fetchDepartureRoomChecks({bookingSetId}),
          () => fetchDepositSummary({bookingSetId}),
          () => fetchRoomChecksTimeline({bookingSetId})
        ];

        this.props.editDepartureRoomCheckStatus(
          {
            bookingSetId,
            departureRoomCheckId
          },
          extraActions
        );
      }
    );
  };

  render() {
    const {
      departureRoomCheck: {
        totalDamageCharge,
        description,
        releaseFullDeposit,
        chargeFromDeposit,
        status
      },
      releaseFullDepositError,
      totalDamageChargeError,
      edittingDescription
    } = this.props;

    const isCompleted = status == ROOM_CHECK_STATUSES.COMPLETED;

    return (
      <div className="DepartureRoomCheckDetails">
        {!_.isNull(releaseFullDepositError) && (
          <ErrorBlock>{releaseFullDepositError}</ErrorBlock>
        )}
        <div className="DepartureRoomCheckDetails__section">
          <CheckBox
            name="releaseFullDeposit"
            label="Release full deposit?"
            value={releaseFullDeposit}
            onChange={this.onReleaseFullDepositChange}
            disabled={chargeFromDeposit}
          />
        </div>
        {!_.isNull(totalDamageChargeError) && (
          <ErrorBlock>{totalDamageChargeError}</ErrorBlock>
        )}
        <div className="DepartureRoomCheckDetails__section">
          <Label>Charge total amount</Label>
          <MoneyInput
            defaultValue={
              this.state.totalDamageChargeEddited || totalDamageCharge
            }
            onChange={this.onTotalDamageChargeChange}
            disabled={releaseFullDeposit}
          />
        </div>
        <div className="DepartureRoomCheckDetails__section">
          <CheckBox
            name="chargeFromDeposit"
            label="To be retained from deposit?"
            value={chargeFromDeposit}
            onChange={this.onChargeFromDepositChange}
            disabled={releaseFullDeposit}
          />
        </div>
        <div className="DepartureRoomCheckDetails__section">
          <CheckBox
            name="completeRoomCheck"
            label="Complete room check?"
            value={isCompleted}
            onChange={this.onStatusChange}
            disabled={isCompleted}
          />
        </div>
        <RoomCheckDescription
          description={description}
          editFormName="editDepartureRoomCheckDescriptionForm"
          submitEditDescriptionForm={this.submitEditDescriptionForm}
          edittingDescription={edittingDescription}
        />
      </div>
    );
  }
}

const mapStateToModalData = state => {
  const modal = selectModal(state, MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL);
  const releaseFullDepositError = _.get(
    modal,
    'data.releaseFullDepositError',
    null
  );
  const totalDamageChargeError = _.get(
    modal,
    'data.totalDamageChargeError',
    null
  );

  return {
    releaseFullDepositError,
    totalDamageChargeError
  };
};

const mapDispatchToProps = {
  editDepartureRoomCheckDescription,
  editDepartureRoomCheckTotalDamageCharge,
  editDepartureRoomCheckChargeFromDeposit,
  editDepartureRoomCheckReleaseFullDeposit,
  editDepartureRoomCheckStatus,
  storeDataInModal,
  composeActions,
  requiresPermission
};

export default connect(mapStateToModalData, mapDispatchToProps)(
  DepartureRoomCheckDetails
);
